import { render, staticRenderFns } from "./StudentStatementImport.vue?vue&type=template&id=b17d30f8"
import script from "../../../controllers/custom/student_statement/student-statement-import.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/student_statement/student-statement-import.js?vue&type=script&lang=js&external"
import style0 from "./StudentStatementImport.vue?vue&type=style&index=0&id=b17d30f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports